import CfEnvvars from '@rover/cloudflare/src/ts/interfaces/cloudflare/CfEnvvars';

export const {
  BYPASS_KV,
  BYPASS_KV_BEFORE_TIMESTAMP,
  CLOUDFLARE_ENVIRONMENT,
  USE_PUBLIC_HOSTNAME, // Provided in the Codespaces dev environment
  SENTRY_DSN,
  SSR_API_KEY,
  GOOGLE_MAPS_SECRET_KEY,
  ROVER_MAINTENANCE_MODE,
}: CfEnvvars = <CfEnvvars>(<unknown>global);
